<template>
	<div id="Mentions">
		<Back />
		<section class="hero is-black is-small">
			<div class="hero-body">
				<div class="container has-text-centered">
					<p class="title has-text-white">Mentions légales</p>
				</div>
			</div>
		</section>

		<div class="container">
			<div class="content has-text-centered">
				<br />La consultation de ce site internet suppose l’acceptation sans réserve des présentes conditions d’utilisation.
				<br />
				<br />
				<b>Nos bureaux</b>
				<br />
				<br />Nos bureaux sont disponibles à l'adresse suivante sur réservation d'un rendez-vous :
				<br />
				<br />
				<blockquote>
					Village des voiles 2
					<br />1 rue de l'union
					<br />59520 Marquette-Lez-Lille
				</blockquote>
				<br />
				<b>Publication</b>
				<br />
				<br />Le présent site est édité et géré par :
				<br />
				<br />SAS Happy Chauffe & Co.
				<br />148 avenue de l’Hippodrome
				<br />59130 Lambersart
				<br />Tél. 03.20.97.30.21
				<br />N° SIRET : 87802561800017
				<br />Responsable publication : M Xavier Fournier et M Fabrice Lourme
				<br />Responsable développement :
				<a href="//github.com/vlourme">M Victor Lourme</a>
				<br />
				<br />
				<b>Droits de propriété intellectuelle</b>
				<br />
				<br />Le site www.happychauffe.fr est protégé par les droits de propriété intellectuelle et est la propriété exclusive de SAS Happy Chauffe & Co.
				<br />
				<br />La conception, le graphisme, le contenu, l’organisation de ce site sont des oeuvres originales et sont l’entière propriété de SAS Happy Chauffe & Co. Toute reproduction, ou démarquage, total ou partiel, fait sans le consentement de l’auteur, ou de ses ayants droit, ou de ses ayants cause est illicite. Il en est de même pour la traduction, l’adaptation, l’arrangement par quelque procédé que ce soit (loi 57298 du 11 mars 1957).
				<br />
				<br />
				<b>Liens hypertextes avec des sites tiers</b>
				<br />
				<br />SAS Happy Chauffe & Co. n’exerce aucun contrôle sur le contenu des sites tiers.
				<br />L’existence d’un lien hypertexte entre le site SAS Happy Chauffe & Co. et un site tiers ne signifie en aucune manière le contrôle du contenu du site tiers par SAS Happy Chauffe & co
				<br />
				<br />
				<b>Exoneration de responsabilité</b>
				<br />
				<br />Il appartient à l’utilisateur de ce site de prendre toutes les mesures appropriées de façon à protéger ses propres données et/ou logiciels de contamination par d’éventuels virus circulant sur le réseau Internet.
				<br />
				<br />
				<b>Modification du site</b>
				<br />
				<br />SAS Happy Chauffe & Co. se réserve le droit de modifier ou de corriger le contenu de ce site et cette mention légale à tout moment et ceci sans préavis.
				<br />
				<br />
				<b>Politique de confidentialité</b>
				<br />
				<br />Le site www.happychauffe.fr attache une importance à l’utilisation de vos données personnelles.
				<br />Nous ne stockons aucune informations hormis les informations que nous recevons via notre formulaire de contact.
				<br />Ne n'utilisons aucuns cookies sur le site www.happychauffe.fr.
				<br />
				<br />
				<b>Indisponibilité du site</b>
				<br />
				<br />SAS Happy Chauffe & Co. s’engage à faire ses meilleurs efforts pour assurer aux utilisateurs une accessibilité du site à tout moment. SAS Happy Chauffe & Co. ne pourra être tenue pour responsable, en cas d’indisponibilité du site, pour quelque cause que ce soit.
				<br />
				<br />
			</div>
		</div>
	</div>
</template>

<style scoped>
.content {
	padding: 1%;
}
blockquote {
	display: inline-block;
	border-radius: 5px;
}
</style>

<script>
import Back from "@/components/Back";

export default {
	components: {
		Back,
	},
};
</script>